import { some, forEach } from 'lodash';
import React from 'react';

import connect from 'components/lib/connect';
import FeatureNotification from './feature_notification';
import useIsFeatureEnabled from 'components/hooks/use_is_feature_enabled';

// When we want to display a new feature notification, just create another props object and add it to the list.
const CURRENT_FEATURES = [];

export function FeatureNotificationList({ agentPreferences }) {
  const isFeatureEnabled = useIsFeatureEnabled();

  let featureNotifications = [];
  forEach(CURRENT_FEATURES, featureProps => {
    const isEnabled = !some(featureProps.flags, flag => !isFeatureEnabled(flag));
    if (isEnabled && !agentPreferences.hasSeenFeatureNotification(featureProps.feature)) {
      featureNotifications.push(<FeatureNotification {...featureProps} />);
    }
  });

  if (!featureNotifications.length) {
    return null;
  }

  return <React.Fragment>{featureNotifications}</React.Fragment>;
}

const FeatureNotificationListContainer = connect(mapStateToProps)(FeatureNotificationList);

function mapStateToProps({ getProvider }) {
  const agentPreferences = getProvider('agentPreferences').get();

  return {
    agentPreferences,
  };
}

export function useHasFeaturesToShow(agentPreferences) {
  const isFeatureEnabled = useIsFeatureEnabled();
  return some(CURRENT_FEATURES, featureProps => {
    const isEnabled = !some(featureProps.flags, flag => !isFeatureEnabled(flag));
    return isEnabled && !agentPreferences.hasSeenFeatureNotification(featureProps.feature);
  });
}

export default FeatureNotificationListContainer;
